import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { QUERY_FIND_FORM_TRANSFER_SETTINGS } from 'graphql/queries/dynamicPortals';
import { FindFormPortalTransferSettingsMany, FindFormPortalTransferSettingsManyVariables } from '../types';

export const useTransferSettingsData = (formId: number, portalUrl: string) => {
    const { loading, data: transferSettingsData } = useQuery<
        FindFormPortalTransferSettingsMany,
        FindFormPortalTransferSettingsManyVariables
    >(QUERY_FIND_FORM_TRANSFER_SETTINGS, { variables: { data: { formId, portalUrl } } });

    const transferSettings = useMemo(
        () => transferSettingsData?.findFormPortalTransferSettingsMany?.[0] || null,
        [transferSettingsData?.findFormPortalTransferSettingsMany]
    );

    return { loading, transferSettings };
};
